<template>
  <div class="cashierlist">
    <div class="list">
      <div class="item" :class="item.isVip == 1 ? 'vips' : 'normals'" v-for="(item, index) in list" :key="index">
        <div class="top">
          <div class="status" :class="item.isVip == 1 ? 'vips_status' : 'normals_status'">
            <span :class="judgeStatus(item)">{{ statusOptions[item.orderStatus] }}</span>
          </div>
          <div class="time" :class="judgeTheme(item)">{{ item.orderTime }}</div>
          <div class="customer" :class="judgeTheme(item)">
            <div class="name">
              <img v-if="item.isVip == 1" :src="require('../assets/img/serviceicon.png')" width="22" height="22" />
              <span v-if="item.isVip == 1">{{ item.vipUserName }}</span>
              <span v-if="item.isVip == 2">普通用户</span>
            </div>
            <div class="tel" v-if="item.isVip == 1">{{ item.vipUserPhone }}</div>
          </div>
        </div>
        <div class="center">
          <div class="ceneter_item" v-for="(item1, index1) in item.projectInfoVoLists" :key="index1">
            <div class="center_name">
              <div class="wrap" :class="judgeTheme(item)">
                <div class="title">{{ item1.projectName }}</div>
                <div class="price">￥{{ item1.price }}</div>
              </div>
              <div class="wrap" style="margin-top: 5px">
                <div class="technician">次数：{{ item1.projectCount }}</div>
                <div class="duration">时长：{{ item1.durationMinute }}分钟</div>
              </div>
            </div>
            <div class="center_list" v-if="item.projectType == 1">
              <div class="center_list_item" :class="judgeTheme(item)" v-for="(item2, index2) in item1.processList" :key="index2">
                <div class="title">{{ item2.processName }}</div>
                <div class="keep">{{ item2.durationMinute }}分钟</div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom">
          <div class="left">
            <div :class="judgeTheme(item)">
              <span>应收金额：</span>
              <span class="money">￥{{ item.payAmount }}</span>
            </div>
            <div v-if="item.orderStatus == 1" class="endtime">结账：{{ item.paymentTime }}</div>
          </div>
          <div class="right" v-if="item.orderStatus == 0">
            <el-button class="cancel" size="small" type="" @click="cancel(item)">取消订单</el-button>
            <el-button :class="item.isVip == 1 ? 'btn1' : 'btn2'" size="small" type="primary" @click="confirm(item)">付款</el-button>
          </div>
          <div class="right" v-if="item.orderStatus == 4">
            <el-button :class="item.isVip == 1 ? 'btn1' : 'btn2'" size="small" type="primary" @click="selectPayStatus(item)">查询支付状态</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
    type: Number,
  },
  data() {
    return {
      statusOptions: { 0: "待结账", 1: "已结账", 3: "已作废", 4: "支付中" },
    }
  },
  created() {},
  methods: {
    /**
     * @param item.isVip 1:vip用户 2:普通用户
     * @param item.orderStatus 0:待结账 1:已结账 3:已作废
     */
    judgeStatus(item) {
      if (item.isVip == 1) {
        return item.orderStatus == 0 ? "danger" : item.orderStatus == 4 ? "danger" : item.orderStatus == 3 ? "info1" : "primary1"
      } else {
        return item.orderStatus == 0 ? "danger" : item.orderStatus == 4 ? "danger" : item.orderStatus == 3 ? "info2" : "primary2"
      }
    },
    /**
     * @param item.isVip 1:vip用户 2:普通用户
     */
    judgeTheme(item) {
      return item.isVip == 1 ? "primary1" : item.isVip == 2 ? "primary2" : ""
    },
    cancel(e) {
      this.$emit("cancel", e)
    },
    confirm(e) {
      this.$emit("confirm", e)
    },
    selectPayStatus(e) {
      this.$emit("select", e)
    },
  },
}
</script>

<style scoped lang="scss">
$color1: #782d00;
$color2: #0f1c40;
$color3: #ee1a1a;
$color4: #707070;
.cashierlist {
  .list {
    display: flex;
    flex-wrap: wrap;
    .vips {
      background: linear-gradient(134deg, #dabd8c 0%, #f8e2ad 100%);
    }
    .normals {
      background: linear-gradient(134deg, #dae0ea 0%, #c1cee4 100%);
    }
    .primary1 {
      color: $color1;
    }
    .primary2 {
      color: $color2;
    }
    .danger {
      color: $color3;
    }
    .info1 {
      color: #9f8873;
    }
    .info2 {
      color: $color4;
    }
    .item {
      position: relative;
      width: 365px;
      height: 530px;
      border-radius: 10px;
      padding: 15px 12px 0;
      margin-right: 20px;
      margin-bottom: 20px;
      box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.06);
      box-sizing: border-box;

      .top {
        width: 100%;
        height: 75px;
        .status {
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          top: 0;
          left: 0;
          width: 80px;
          height: 40px;
          font-size: 16px;
          border-radius: 10px 0 10px 0;
        }

        .vips_status {
          color: $color1;
          background: linear-gradient(226deg, #f5ddb2 0%, #ffeecf 100%);
        }
        .normals_status {
          color: $color2;
          background: linear-gradient(226deg, #6282d5 0%, #c4d3ff 100%);
        }
        .time {
          font-size: 14px;
          text-align: right;
          margin-bottom: 18px;
        }
        .customer {
          display: flex;
          align-items: flex-end;
          .name {
            display: flex;
            align-items: center;
            font-size: 20px;
            font-weight: bold;
            margin-right: 8px;
            img {
              margin-right: 8px;
            }
          }
          .tel {
            font-size: 14px;
          }
        }
      }
      .center {
        width: 100%;
        height: calc(100% - 75px - 65px);
        padding-right: 3px;
        border-top: 1px solid rgba(3, 16, 14, 0.06);
        border-bottom: 1px solid rgba(3, 16, 14, 0.06);
        overflow-y: auto;

        .center_name {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          padding-top: 10px;
          width: 100%;
          .wrap {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
          }
          .title,
          .technician {
            flex: 1;
          }
          .price,
          .duration {
            width: 120px;
            text-align: right;
          }
          .title,
          .price {
            font-size: 16px;
            font-weight: bold;
          }
          .technician,
          .duration {
            color: $color4;
            font-size: 15px;
          }
        }
        .center_list {
          width: 100%;
          padding-top: 15px;
          .center_list_item {
            display: flex;
            justify-content: space-between;
            font-size: 15px;
            padding-left: 10px;
            margin-bottom: 10px;
          }
        }
      }

      .bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 65px;
        font-size: 16px;
        .left {
          .money {
            color: $color3;
            font-weight: bold;
          }
          .endtime {
            color: $color4;
            font-size: 12px;
            margin-top: 5px;
          }
        }
        .right {
          .cancel {
            color: $color4;
            background-color: transparent;
            border-color: $color4;
            &:hover {
              opacity: 0.5;
            }
          }
          .btn1 {
            color: #fff;
            background-color: $color1;
            border-color: $color1;
            &:hover {
              opacity: 0.5;
            }
          }
          .btn2 {
            color: #fff;
            background-color: $color2;
            border-color: $color2;
            &:hover {
              opacity: 0.5;
            }
          }
        }
      }
    }
  }
}
// scroll滚动条
*::-webkit-scrollbar {
  width: 3px !important;
}

*::-webkit-scrollbar-thumb {
  background: #a3a3a3;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
}

*::-webkit-scrollbar-thumb:hover {
  background-color: $color4;
}
</style>
